/* eslint-disable import/extensions */
import Swiper from "swiper";
import { Navigation, EffectCoverflow } from "swiper/modules";
import { trackEvent } from "../made-category-print-analytics";
import "swiper/css";
import "./review-tabs.scss";

const ROOT_SELECTOR = ".js-review-tabs";
const SWIPER_SELECTOR = ".js-review-tabs-swiper";
const PREV_SELECTOR = ".js-review-tabs-button-prev";
const NEXT_SELECTOR = ".js-review-tabs-button-next";

const SPACE_BETWEEN = 20;
const DEFAULT_SLIDES_PER_VIEW = 1.3;
const EFFECT_COVERFLOW = "coverflow";
const COVERFLOW_EFFECT_CONFIG = {
  rotate: 0,
  stretch: 0,
  depth: 100,
  modifier: 1,
  slideShadows: true
};
const BREAKPOINTS = {
  768: { slidesPerView: 2.3 },
  992: { slidesPerView: 3.2 }
};

const $getRoot = () => document.querySelector(ROOT_SELECTOR);
const $getContainer = $root => $root.querySelector(SWIPER_SELECTOR);
const $getPrevEl = $root => $root.querySelector(PREV_SELECTOR);
const $getNextEl = $root => $root.querySelector(NEXT_SELECTOR);

let swiperInstance = null;
let trackingController = null;

function trackCarouselNav(direction) {
  trackEvent("clp_review_carousel_navigated", {
    section_identifier: "review_tabs",
    direction,
    eventLabel: direction
  });
}

function initSwiper($root) {
  const $container = $getContainer($root);
  if (!$container) return;

  if (swiperInstance) {
    swiperInstance.update();
    return;
  }

  const $prev = $getPrevEl($root);
  const $next = $getNextEl($root);

  swiperInstance = new Swiper($container, {
    modules: [Navigation, EffectCoverflow],
    observer: true,
    observeParents: true,
    effect: EFFECT_COVERFLOW,
    coverflowEffect: COVERFLOW_EFFECT_CONFIG,
    loop: true,
    slidesPerView: DEFAULT_SLIDES_PER_VIEW,
    spaceBetween: SPACE_BETWEEN,
    centeredSlides: true,
    breakpoints: BREAKPOINTS,
    navigation: { prevEl: $prev, nextEl: $next, addIcons: false }
  });

  // AbortController ties listener lifetime to the swiper — destroyed together.
  trackingController = new AbortController();
  const { signal } = trackingController;
  $prev?.addEventListener("click", () => trackCarouselNav("left"), { signal });
  $next?.addEventListener("click", () => trackCarouselNav("right"), { signal });
}

function destroySwiper() {
  trackingController?.abort();
  trackingController = null;
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }
}

let listenersAttached = false;

function ensureListeners() {
  if (listenersAttached) return;
  listenersAttached = true;
  document.addEventListener("turbolinks:before-cache", destroySwiper);
}

export default function initReviewTabs() {
  const $root = $getRoot();
  if (!$root) return;

  ensureListeners();
  initSwiper($root);
}
